import { computed, ref } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';
import WhatsappTemplatesAPI from 'dashboard/api/whatsappTemplates';

// Número OFICIAL (Cloud API / 360dialog) só entrega template aprovado para
// quem nunca respondeu. Quem não é oficial aceita texto livre.
const PROVEDORES_OFICIAIS = ['whatsapp_cloud', 'default'];

// Templates aprovados de uma caixa, buscados sob demanda e guardados por id.
// Serve tanto o rodízio (uma caixa por atendente) quanto a caixa geral da
// integração, que é o caso de quem usa um número só.
export function useWhatsappTemplates(inboxes) {
  const getters = useStoreGetters();
  const accountId = computed(() => getters.getCurrentAccountId.value);

  const porCaixa = ref({});
  const carregando = ref({});

  const caixaPorId = computed(() =>
    (inboxes.value || []).reduce(
      (acc, inbox) => ({ ...acc, [inbox.id]: inbox }),
      {}
    )
  );

  const ehOficial = inboxId =>
    PROVEDORES_OFICIAIS.includes(caixaPorId.value[inboxId]?.provider);

  const carregar = async inboxId => {
    const id = Number(inboxId) || null;
    if (!id || porCaixa.value[id] || carregando.value[id]) return;
    if (!ehOficial(id)) return;

    carregando.value = { ...carregando.value, [id]: true };
    try {
      const { data } = await WhatsappTemplatesAPI.getTemplates(
        accountId.value,
        id
      );
      const lista = Array.isArray(data) ? data : data?.payload || [];
      porCaixa.value = {
        ...porCaixa.value,
        // Oferecer template não aprovado seria prometer um envio que a Meta
        // recusa na hora.
        [id]: lista.filter(
          item => String(item.status).toLowerCase() === 'approved'
        ),
      };
    } catch {
      porCaixa.value = { ...porCaixa.value, [id]: [] };
    } finally {
      carregando.value = { ...carregando.value, [id]: false };
    }
  };

  const templatesDe = inboxId => porCaixa.value[Number(inboxId)] || [];
  const estaCarregando = inboxId => !!carregando.value[Number(inboxId)];

  return { ehOficial, carregar, templatesDe, estaCarregando };
}
